module.exports = __webpack_public_path__ + "img/Monster.135048f9.svg";